<template>
  <div class="achievement">
    <div class="form-item">
      <label class="label"><i class="required">*</i>擅长行业：</label>
      <div class="input-box">
        <el-select filterable v-model="comIndustryList" multiple placeholder="请选择擅长行业">
          <el-option  v-for="(item,index) in industryList" :key="'Industry'+index" :label="item.name" :value="item.id" ></el-option>
        </el-select>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>期望服务城市：</label>
      <div class="input-box">
        <el-cascader 
          v-model="expectCityList" 
          clearable
          :options="provinceList" 
          :props="{value:'ID',label:'name',children:'cityList',multiple: true,emitPath:true}"
        ></el-cascader>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>资质证书：</label>
      <div class="input-box">
        <div class="cert-item" v-if="!showAddCert && addCertRadio === '无证书'"><div class="cert-name">无证书</div></div>
        <div class="cert-item" v-for="(item,index) in comCertificateList" :key="index">
          <div class="cert-name">
            {{item.certificateName}}
            <span class="btn-text" @click="removeCert(index)">删除</span>
          </div>
          <ul class="cert-pics">
            <li v-if="item.certificateURL">
              <img class="pic" :src="item.certificateURL" alt="">
            </li>
            <li v-if="item.certificateURL2">
              <img class="pic" :src="item.certificateURL2" alt="">
            </li>
          </ul>
        </div>
        <div class="btn-add" @click="showAddCert=true">
          <i class="el-icon el-icon-plus"></i>
          添加
        </div>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>项目经历：</label>
      <div class="input-box">
        <ul class="project-list">
          <li class="project-item" v-for="(item,index) in successfulCaseList" :key="index">
            <div class="flex flex-center">
              <div class="name">{{item.projectName}}</div>
              <span class="time" v-if="item.projectAmount">项目金额：￥{{item.projectAmount}}</span>
              <span class="time">{{item.projectYear}}</span>
            </div>
            <div class="flex">
              <div class="project-info">
                <span class="info-label">行业：</span>
                <span class="value">{{item.industryName}}</span>
              </div>
              <div class="project-info">
                <span class="info-label">服务类型：</span>
                <span class="value">{{item.twoProductName}}-{{item.threeProductName}}-{{item.serviceTypeName}}</span>
              </div>
              <div class="project-info">
                <span class="info-label">项目描述：</span>
                <span class="value">{{item.serviceDesc}}</span>
              </div>
              <span class="btn-text" @click="removeProject(index)">删除</span>
            </div>
          </li>
        </ul>
        <div class="btn-add" @click="showAddProject=true" v-if="successfulCaseList.length<5">
          <i class="el-icon el-icon-plus"></i>
          添加
        </div>
      </div>
    </div>
    <div class="form-item">
      <label class="label">我的工程师：</label>
      <div class="input-box">
        <table class="table">
          <tr>
            <th>工程师姓名</th>
            <th>手机号</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item,index) in comEngineerList" :key="index">
            <td>{{item.TrueName}}</td>
            <td>{{item.Handset}}</td>
            <td><span class="btn-text" @click="removeEngineer(index)">删除</span></td>
          </tr>
        </table>
        <div class="btn-add" @click="showAddEngineer=true">
          <i class="el-icon el-icon-plus"></i>
          添加
        </div>
      </div>
    </div> 
    <div class="form-item">
      <label class="label"></label>
      <div class="input-box">
        <el-checkbox v-model="isAgree" class="agree-deal" :true-label="1" :false-label="0">
          <span class="agree">我已阅读并同意</span>
          <a class="deal" target="_blank" href="/Help/helpCenter_09.html">《工业速派使用协议》、</a>
          <a class="deal" target="_blank" href="/Help/helpCenter_12.html">《工业速派隐私权条款》、</a>
          <a class="deal" target="_blank" :href="deal3">《工业速派服务商行为规则》</a>
        </el-checkbox>
      </div>
    </div>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <button class="btn-default" @click="prevStep">上一步</button>
        <button class="btn-primary" @click="validData">提交</button>
      </div>
    </div>
    <my-dialog class="form-dialog" :show="showAddCert" titleCenter title="资质证书" @close="showAddCert=false;addCertRadio=''" width="600px">
      <div class="inner-form">
        <div class="form-item"  v-if="showAddCert !== '有证书'">
          <el-radio-group class="radio-group" v-model="addCertRadio">
            <el-radio label="无证书" ></el-radio>
            <el-radio label="有证书" ></el-radio>
          </el-radio-group>
          <button class="btn-primary" @click="comfirmCertRadio">确认</button>
        </div>
        <block v-if="showAddCert === '有证书'">
          <div class="form-item" >
            <label class="label"><i class="required">*</i>证书名称：</label>
            <div class="input-box">
              <el-select filterable v-model="certName" value-key="CodeName1" placeholder="请选择" >
                <el-option  v-for="(item,index) in certNameList" :key="index"  :value="item" :label="item.CodeName1"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-item">
            <label class="label"><i class="required">*</i>证书编号：</label>
            <div class="input-box">
              <input class="input" v-model.trim="certForm.certificateNo" type="text" placeholder="证书编号" >
            </div>
          </div>
          <div class="form-item">
            <label class="label"><i class="required">*</i>有效期限：</label>
            <div class="input-box">
              <el-date-picker
                class="block-date"
                v-model="certForm.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
          <div class="form-item">
            <label class="label"><i class="required">*</i>证书图片：</label>
            <div class="input-box">
              <el-upload
                class="btn-upload"
                :action="UploadImg"
                :on-success="uploadFace"
                :before-upload="beforeUpload"
                :show-file-list="false"
                accept="image/*"
              >
                <i class="card-file">正面（必填）</i>
                <img v-if="certForm.certificateURL" :src="certForm.certificateURL" alt="" class="file-img">
              </el-upload>
              <el-upload
                class="btn-upload"
                :action="UploadImg"
                :on-success="uploadBack"
                :before-upload="beforeUpload"
                :show-file-list="false"
                accept="image/*"
              >
                <i class="card-file">反面（选填）</i>
                <img v-if="certForm.certificateURL2" :src="certForm.certificateURL2" alt="" class="file-img">
              </el-upload>
            </div>
          </div>
          <button class="btn-primary" @click="confirmCert">确认</button>
        </block>
        
      </div>
    </my-dialog>
    <my-dialog class="form-dialog" :show="showAddProject" titleCenter title="项目经历" @close="showAddProject=false" width="650px">
      <div class="inner-form">
        <div class="form-item">
          <label class="label"><i class="required">*</i>项目名称：</label>
          <div class="input-box">
            <input class="input" v-model.trim="projectForm.projectName" maxlength="30" type="text" placeholder="项目名称" >
          </div>
        </div>
        <div class="form-item">
          <label class="label"><i class="required">*</i>行业：</label>
          <div class="input-box">
            <el-select filterable v-model="projectForm.industryId" placeholder="请选择行业">
              <el-option  v-for="(item,index) in industryList" :key="index" :label="item.name" :value="item.id" ></el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <label class="label"><i class="required">*</i>服务类型：</label>
          <div class="input-box">
            <el-select class="sp-select" filterable v-model="projectForm.ProductId" placeholder="请选择" @change="getThreeProductList">
              <el-option  :value="item.ProductId" v-for="(item,index) in secondProductList" :key="index" :label="item.ProductName"></el-option>
            </el-select>
            <!-- <span class="line"></span> -->
            <el-select class="sp-select" filterable v-model="projectForm.threeProductId " placeholder="请选择"  :loading="threeProductList.length==0" @change="loadServiceStage">
              <el-option  :value="item.ProductId" v-for="(item,index) in threeProductList" :key="index" :label="item.ProductName"></el-option>
            </el-select>
            <!-- <span class="line"></span> -->
            <el-select class="sp-select" filterable v-model="projectForm.serviceTypeId " placeholder="请选择"  :loading="serviceStagesList.length==0">
              <el-option  :value="item.ServiceStageId" v-for="(item,index) in serviceStagesList" :key="index" :label="item.ServiceStageName"></el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <label class="label"><i class="required">*</i>项目时间：</label>
          <div class="input-box">
            <el-date-picker
              class="block-date"
              v-model="projectForm.projectYear"
              value-format="yyyy"
              :picker-options="limitYear"
              type="year"
              placeholder="选择年份">
            </el-date-picker>
          </div>
        </div>
        <div class="form-item">
          <label class="label"><i class="required">*</i>项目金额：</label>
          <div class="input-box">
            <input class="input" type="number" v-model.trim="projectForm.projectAmount" placeholder="请输入项目金额" >
          </div>
        </div>
        <div class="form-item">
          <label class="label">项目描述：</label>
          <div class="input-box">
            <textarea class="textarea" v-model.trim="projectForm.serviceDesc" maxlength="100" placeholder="100字以内"></textarea>
          </div>
        </div>
        <button class="btn-primary" @click="confirmProject">确认</button>
      </div>
    </my-dialog>
    <my-dialog class="form-dialog" :show="showAddEngineer" titleCenter title="添加工程师" @close="showAddEngineer=false" width="600px">
      <div class="inner-form">
        <div class="form-item">
          <label class="label"><i class="required">*</i>工程师姓名：</label>
          <div class="input-box">
            <input class="input" v-model.trim="engineerForm.trueName" type="text" placeholder="工程师姓名" >
          </div>
        </div><div class="form-item">
          <label class="label"><i class="required">*</i>手机号：</label>
          <div class="input-box">
            <input class="input" v-model.trim="engineerForm.handset" type="text" placeholder="手机号" >
          </div>
        </div>
        <button class="btn-primary" @click="confirmEngineer">确认</button>
      </div>
    </my-dialog>
    <my-dialog class="form-dialog" :show="showMessage" titleCenter title="短信认证" @close="showMessage=false" width="600px">
      <div class="inner-form">
        <div class="form-item">
          <label class="label"><i class="required">*</i>手机号：</label>
          <div class="input-box">
            <input class="input" v-model.trim="phone" readonly type="text" placeholder="手机号" >
          </div>
        </div><div class="form-item">
          <label class="label"><i class="required">*</i>验证码：</label>
          <div class="input-box">
            <input class="input" v-model.trim="code" type="text" placeholder="验证码" >
            <button class="btn-code" @click="getCode" :disabled="btnDisabled">{{codeBtnText}}</button>
          </div>
        </div>
        <button class="btn-primary" @click="validContract">确认</button>
      </div>
    </my-dialog>
    <el-dialog
    :visible.sync="buyMemberDialogId"
    width="50%"
    center
    :before-close="buyMemberDialogClose">
    <h3>恭喜您提交成功，需要专家认证后才能接单，专家认证费用{{authAmount}}，购买会员可免专家认证费用。</h3>
    <span slot="footer" class="dialog-footer">
      <el-button @click="buyCertificationConfirm">立即付款</el-button>
      <el-button type="primary" @click="buyMemberConfirm">购买会员</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>
import { 
  GetIndustry,
  GetAreas,
  ServiceStagesByDomain,
  ProductBrands,
  CodeLines,
  SearchEngineer,
  ApplyServiceStation,
  TianWeiSendMobileCode,
  CompanySignServiceStationContract,
  SubmitServiceSiteEdit,
  AddErrorLog,
  UploadImg,
  ThreeProductList,
} from '@/scripts/api.js'
import Dialog from "@/components/gkDialog.vue";
import validate from '@/scripts/validate.js'
import {bpoAlert} from '@/scripts/bpo.js'
import Bus from '@/scripts/bus.js'
import {mapState} from 'vuex'
export default {
  name:'achievement',
  components:{
    "my-dialog": Dialog,
  },
  data(){
    return{
      UploadImg,
      showAddCert:false,
      industryList:[],
      comIndustryList:[],
      expectCityList :[],
      comCertificateList :[],
      successfulCaseList:[],
      comEngineerList:[],
      provinceList:[],
      isAgree:false,
      productList:[],
      brandList:[],
      certForm:{
        certificateName:'',
        certificateType:'',
        certificateURL:'',
        certificateURL2:'',
        certificateNo:'',
        endTime:'',
        // productID:'',
        // brandID:'',
      },
      certName:'',
      showAddProject:false,
      threeProductList: [],
      serviceStagesList:[],
      projectForm:{
        projectName:'',
        industryId:'',
        industryName:'',
        domainId:'',
        ProductId: '',
        threeProductId: '',
        serviceTypeId:'',
        serviceTypeName:'',
        projectYear:'',
        projectAmount: "",
        serviceDesc:'',
      },
      limitYear:{
        disabledDate(time){
          return time.getFullYear()>new Date().getFullYear();
        }
      },
      certNameList:[],//证书列表
      showAddEngineer:false,
      engineerForm:{
        trueNme:'',
        handset:'',
      },
      serviceAuthData:null,
      phone:'',
      code:'',
      showMessage:false,
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
      companyId:0,
      isSign:false,//是否签约过注册服务站合同
      deal3:'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/bpoContract/%E5%B7%A5%E4%B8%9A%E9%80%9F%E6%B4%BE%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1%E7%AB%99%E5%8A%A0%E7%9B%9F%E8%A7%84%E5%88%99.pdf',
      addCertRadio: "",
      buyMemberDialogId: null,
      authAmount: 0,
      buyMemberDialogTo: ''
    }
  },
  props:{
    isEdit:{
      type:Boolean,
      default:false,
    }
  },
  computed: {
    ...mapState({
      serviceInfo:state=>state.serviceInfo,
      userInfo:state=>state.userInfo,
      secondProductList: state => state.secondProductList,
    })
  },
  watch: {
    'certForm.productID':function (value) {
      this.brandList=[];
      if(value){
        this.loadProductList(value);
      }
    },
    certName (value) {
      if(value){
        this.certForm.certificateName = value.CodeName1;
        this.certForm.certificateType = value.CodeValue;
      }
    },
    'projectForm.industryId':function (value) {
      if(value){
        for (let i = 0; i < this.industryList.length; i++) {
          if(value==this.industryList[i].id){
            this.projectForm.industryName=this.industryList[i].name;
          }
        }
      }
    },
    'projectForm.serviceTypeId':function (value) {
      if(value){
        for (let i = 0; i < this.serviceStagesList.length; i++) {
          if(value==this.serviceStagesList[i].ServiceStageId){
            this.projectForm.serviceTypeName=this.serviceStagesList[i].ServiceStageName;
          }
        }
      }
    },
    'projectForm.ProductId':function (value) {
      if(value){
        for (let i = 0; i < this.secondProductList.length; i++) {
          if(value==this.secondProductList[i].ProductId){
            this.projectForm.twoProductName=this.secondProductList[i].ProductName;
          }
        }
      }
    },
    'projectForm.threeProductId':function (value) {
      if(value){
        for (let i = 0; i < this.threeProductList.length; i++) {
          if(value==this.threeProductList[i].ProductId){
            this.projectForm.threeProductName=this.threeProductList[i].ProductName;
          }
        }
      }
    },
    'projectForm.projectAmount':function (value) {
      if(value.length > 8){
        this.projectForm.projectAmount= value.slice(0,8)
      }
    },
    serviceInfo(value){
      if(value){
        this.comEngineerList=value.ComUserEngineerList;
        this.isSign=value.IsSignServiceSiteContract;
        //证书列表
        this.comCertificateList=[];
        if(!value.ComAccountCertList.length) {
          this.addCertRadio = "无证书"
        }else {
          for (let i = 0; i < value.ComAccountCertList.length; i++) {
            this.comCertificateList.push({
              certificateName:value.ComAccountCertList[i].Name,
              certificateType:value.ComAccountCertList[i].CertificateType,
              certificateURL:value.ComAccountCertList[i].CertificateURL,
              certificateURL2:value.ComAccountCertList[i].CertificateURL2,
              certificateNo:value.ComAccountCertList[i].CertificateNo,
              endTime:value.ComAccountCertList[i].EndTime.substr(0,10),
              // productID:value.ComAccountCertList[i].ProductId || 0,
              // brandID:value.ComAccountCertList[i].BrandId || 0,
            })
          }
        }
        //服务行业
        this.comIndustryList=[];
        for (let i = 0; i < value.ComIndustryList.length; i++) {
          this.comIndustryList.push(value.ComIndustryList[i].IndustryId);
        }
        //期望城市
        let citys=[];
        for (let i = 0; i < value.ExpectCityList.length; i++) {
          citys.push([value.ExpectCityList[i].ProvinceId,value.ExpectCityList[i].CityId])
        }
        this.expectCityList=citys;
        //成功案例
        let caseList=[];
        for (let i = 0; i < value.SuccessfulCaseList.length; i++) {
          caseList.push({
            projectName:value.SuccessfulCaseList[i].ProjectName,
            industryId:value.SuccessfulCaseList[i].IndustryId,
            industryName:value.SuccessfulCaseList[i].IndustryName,
            serviceTypeId:value.SuccessfulCaseList[i].ServiceTypeId,
            serviceTypeName:value.SuccessfulCaseList[i].ServiceTypeName,
            projectYear:value.SuccessfulCaseList[i].ProjectYear,
            projectAmount:value.SuccessfulCaseList[i].ProjectAmount,
            serviceDesc:value.SuccessfulCaseList[i].ServiceDesc,
            threeProductId: value.SuccessfulCaseList[i].ThreeProductId,
            threeProductName: value.SuccessfulCaseList[i].ThreeProductName,
            twoProductId: value.SuccessfulCaseList[i].TwoProductId,
            twoProductName: value.SuccessfulCaseList[i].TwoProductName,
          })
        }
        this.successfulCaseList=caseList;
      }
    },
    expectCityList(value){
      if(value.length>5){
        this.$toast('期望服务城市不能超过5个');
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    let that=this;
    Bus.$on('toServiceAuth3',params=>{
      that.serviceAuthData=params;
      that.companyId=params.companyId,
      that.phone=params.handSet,
      console.log(params);
    })
  },
  methods: {
    //上一步
    prevStep(){
      this.$emit('stepChange',3);
    },
    init(){
      // 行业列表
      GetIndustry({
        platform:'pcweb',
        parentID: 0
      }).then(r=>{
        if(r.Result==1){
          this.industryList=r.Data;
        }
      })
      //获取省市区
      GetAreas({
        platform :'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.provinceList=r.Data.province || [];
        }
      })
      //证书列表
      CodeLines({
        CodeName: "CertificateType",
        CodeName2: "企业证书",
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.certNameList=r.Data.Lines || []
        }
      })
      this.loadProductList();
    },
    //加载产品和品牌
    loadProductList(productId){
      let params=params={
          platform:'pcweb',
        };
      if(productId){
        params={
          platform:'pcweb',
          ProductId:productId,
        }
      }
      ProductBrands(params).then(r=>{
        if(r.Result==1){
          let list=r.Data || [];
          if(productId){
            this.brandList=list.length?list[0].Brands:[];
          }else{
            this.productList=list;
          }
        }
      })
    },
    //上传之前
    beforeUpload(file){
      let isLtSize = file.size / 1024 / 1024 < 10;
      if (!isLtSize) {
        this.$toast('上传文件大小不能超过 10MB!');
      }
      let fileType=file.name.substr(file.name.lastIndexOf('.'));
      let fileArr=['.jpg','.jpeg','.gif','.png',]
      let isFileAllowed=fileArr.indexOf(fileType.toLowerCase())!==-1;
      if (!isFileAllowed) {
        this.$toast('上传文件格式不允许!');
      }
      return isLtSize && isFileAllowed;
    },
    //上传证书正面
    uploadFace(file,res){
      if(file.Result==1){
        this.certForm.certificateURL=file.Data[0].imgUrl;
      }else{
        this.$toast(file.Message);
      }
    },
    //上传证书反面
    uploadBack(file,res){
      if(file.Result==1){
        this.certForm.certificateURL2=file.Data[0].imgUrl;
      }else{
        this.$toast(file.Message);
      }
    },
    //添加证书
    confirmCert(){
      // if(this.certForm.productID==''){
      //   this.$toast('请选择产品设备');
      //   return;
      // }
      // if(this.certForm.brandID==''){
      //   this.$toast('请选择产品品牌');
      //   return;
      // }
      if(this.certForm.certificateType===null || this.certForm.certificateType===''){
        this.$toast('请选择证书名称');
        return;
      }
      if(this.certForm.certificateNo==''){
        this.$toast('请输入证书编号');
        return;
      }
      if(this.certForm.endTime==''){
        this.$toast('请选择证书有效期');
        return;
      }
      if(this.certForm.certificateURL==''){
        this.$toast('请上传证书正面照片');
        return;
      }
      this.comCertificateList.push({
        ...this.certForm,
      });
      this.certForm={
        certificateName:'',
        certificateType:'',
        certificateURL:'',
        certificateURL2:'',
        // productID:'',
        // brandID:'',
        certificateNo:'',
        endTime:'',
      }
      this.certName = {}
      this.showAddCert=false;
      this.addCertRadio = "";
    },
    //加载服务类型
    loadServiceStage(){
      this.projectForm.serviceTypeId='';
      this.serviceStagesList=[];
      ServiceStagesByDomain({
        ProductDomainId: 0,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.serviceStagesList=r.Data.Lines;
        }
      });
    },
    //删除证书
    removeCert(i){
      this.comCertificateList.splice(i,1);
    },
    //添加项目
    confirmProject(){
      if(this.projectForm.projectName==''){
        this.$toast('请输入项目名称');
        return;
      }
      if(this.projectForm.industryId==''){
        this.$toast('请选择行业');
        return;
      }
      if(this.projectForm.serviceTypeId==''){
        this.$toast('请选择服务类型');
        return;
      }
      if(this.projectForm.projectYear==''){
        this.$toast('请选择项目年份');
        return;
      }
      if(this.projectForm.projectAmount=='' || this.projectForm.projectAmount <0 ){
        this.$toast('请输入项目金额且不能小于0');
        return;
      }
      
      this.successfulCaseList.push({
        ...this.projectForm,
        projectAmount: Number(this.projectForm.projectAmount).toFixed(2)
      })
      this.projectForm={
        projectName:'',
        industryId:'',
        domainId:'',
        ProductId: '',
        threeProductId: '',
        serviceTypeId:'',
        projectYear:'',
        projectAmount: '',
        serviceDesc:'',
      }
      this.showAddProject=false;
    },
    //删除项目
    removeProject(index){
      this.successfulCaseList.splice(index,1)
    },
    //查询工程师并添加
    confirmEngineer(){
      if(this.engineerForm.trueName==''){
        this.$toast('请输入工程师姓名');
        AddErrorLog('/SearchEngineer','请输入工程师姓名');
        return;
      }
      if(this.engineerForm.handset==''){
        this.$toast('请输入工程师手机号');
        AddErrorLog('/SearchEngineer','请输入工程师手机号');
        return;
      }
      if (!validate.phone(this.engineerForm.handset)) {
        this.$toast("手机号格式不正确");
        AddErrorLog('/SearchEngineer','手机号格式不正确');
        return;
      }
      SearchEngineer({
        trueName:this.engineerForm.trueName,
        userHandSet:this.engineerForm.handset,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          let obj=r.Data;
          let flag=false;
          for (let i = 0; i < this.comEngineerList.length; i++) {
            if(obj.UserId == this.comEngineerList[i].UserId){
              flag=true;
            }
          }
          if(!flag){
            this.comEngineerList.push(obj);
          }else{
            this.$toast('该工程师已添加！')
          }
          this.showAddEngineer=false;
        }else{
          this.$toast(r.Message);
          AddErrorLog('/SearchEngineer',r.Message);
        }
      })
    },
    //删除工程师
    removeEngineer(index){
      this.comEngineerList.splice(index,1);
    },
    
    //获取验证码
    getCode() {
      var that = this;
      if (this.phone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.phone !== "" &&
        !validate.phone(this.phone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      TianWeiSendMobileCode({
        phone: that.phone,
        codeType: 110,
        loginCompanyId: that.companyId,
        platform: "pcweb"
      }).then(r => {
        // myCaptcha.hide();
        if (r.Result == 1) {
          let time = 60;
          that.btnDisabled = true;
          that.timer = setInterval(() => {
            time--;
            that.codeBtnText = time + "s";
            if (time <= 0) {
              time = 60;
              that.btnDisabled = false;
              that.codeBtnText = "获取验证码";
              clearInterval(that.timer);
            }
          }, 1000);
          that.$toast(r.Message);
        } else {
          bpoAlert(r.Message);
        }
      });
    },
    //验证合同
    validContract(){
      CompanySignServiceStationContract({
        loginCompanyId:this.companyId,
        handset:this.phone,
        mobileCode:this.code,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.showMessage=false;
          this.code='';
          this.isSign=true;
          this.submit();
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //校验
    validData(){
      if(this.comIndustryList.length==0){
        this.$toast('请选择擅长行业');
        AddErrorLog('/ApplyServiceStation','请选择擅长行业');
        return false;
      }
      if(this.expectCityList.length==0){
        this.$toast('请选择期望服务城市，最多5个');
        AddErrorLog('/ApplyServiceStation','请选择期望服务城市，最多5个');
        return false;
      }
      if(this.expectCityList.length>5){
        this.$toast('期望服务城市不能超过5个');
        return;
      }
      if(!this.addCertRadio && this.comCertificateList.length == 0){
        this.$toast('请添加资质证书');
        return;
      }
      if(this.successfulCaseList.length==0){
        this.$toast('请添加项目经历');
        AddErrorLog('/ApplyServiceStation','请添加项目经历');
        return false;
      }
      if(!this.isAgree){
        this.$toast('请仔细阅读并同意速派协议');
        AddErrorLog('/ApplyServiceStation','请仔细阅读并同意速派协议');
        return false;
      }
      if(this.isEdit && this.userInfo && this.userInfo.LoginAccountId){
        this.companyId=this.userInfo.LoginAccountId;
        this.phone=this.userInfo.Handset;
      }
      if(this.isSign){
        this.submit();
      }else{
        this.showMessage=true;
      }
    },
    //提交
    submit(){
      var citys=[];
      for (let i = 0; i < this.expectCityList.length; i++) {
        let obj={
          provinceId:this.expectCityList[i][0],
          cityId:this.expectCityList[i][1],
        }
        citys.push(obj);
      }
      // let isMaintenanceData=getQueryString('isMaintenanceData') || 0;
      let engineerList=this.comEngineerList.map(item=>{
        return item.UserId;
      })
      let params={
        ...this.serviceAuthData,
        companyId:this.companyId,
        isMaintenanceData:0,
        comIndustryList:this.comIndustryList,
        expectCityList:citys,
        comCertificateList:this.comCertificateList,
        successfulCaseList:this.successfulCaseList,
        comEngineerList:engineerList,
      };
      if(this.isEdit && this.userInfo && this.userInfo.IsHasPickJobPermission){//IsServiceSite
        //编辑服务站
        SubmitServiceSiteEdit(params).then(r=>{
          if(r.Result==1){
            // 5.3需求，修改创建流程，自动登录若是返回PayId则需要跳到支付页，否则跳到首页
            if(r.Data.PayId) {
              this.buyMemberDialogId = r.Data.PayId;
              this.authAmount = r.Data.AuthAmount;
              this.buyMemberDialogTo = "/center/serviceSiteInfo";
            }else {
              //返回维护服务站
              this.$router.replace('/center/serviceSiteInfo');
            }
          }else{
            this.$toast(r.Message);
            AddErrorLog('/SubmitServiceSiteEdit','编辑失败');
          }
          if(r.Result==604){
            this.$router.push('/center/companyRealName')
          }
        })
      }else{
        //申请服务站
        ApplyServiceStation(params).then(async r=>{
          if(r.Result==1){
            let data=r.Data || {};
            if(this.isEdit){
              // 5.3需求，修改创建流程，自动登录若是返回PayId则需要跳到支付页，否则跳到首页
              if(data.PayId) {
                this.buyMemberDialogId = data.PayId;
                this.authAmount = data.AuthAmount;
                this.buyMemberDialogTo = "/center/serviceSiteInfo";
              }else {
                //返回维护服务站
                this.$router.replace('/center/serviceSiteInfo');
              }
            }else{
              // 服务站注册进入
              //储存用户信息，并获取用户权限
              data['LoginAccountType']=2;
              data['LoginAccountId']=this.companyId;
              this.$store.commit('setUserInfo',data);
              await this.$store.dispatch('loadAccountData');
              await this.$store.dispatch('loadPermission');
              this.$setCompanyCookies(this.companyId,this.serviceAuthData.companyName);
              // 5.3需求，修改创建流程，自动登录若是返回PayId则需要跳到支付页，否则跳到首页
              if(data.PayId) {
                this.buyMemberDialogId = data.PayId;
                this.authAmount = data.AuthAmount;
                this.buyMemberDialogTo = "/home";
              }else {
                this.$router.replace('/home');
              }
            }
          }else{
            this.$toast(r.Message);
            AddErrorLog('/ApplyServiceStation','注册失败');
          }
        })
      }
    },
    comfirmCertRadio() {
      if(this.addCertRadio === "无证书") {
        this.showAddCert = false;
        this.addCertRadio = "无证书";
      }else {
        this.showAddCert = "有证书"
      }
    },
    // 新增二级产品、三级产品
    getThreeProductList(id) {
            ThreeProductList({ParentId: id}).then(r=>{
                if(r.Result==1){
                    this.threeProductList = r.Data.ProductList;
                }
            })
    },
    // 立即付款 跳去支付
    buyCertificationConfirm() {
      this.$router.push({
        path:'/payment',
        query:{
            payId: this.buyMemberDialogId 
        }
      })
      this.buyMemberDialogId = null;
    },
    buyMemberConfirm() {
      this.buyMemberDialogId = null;
      this.$router.push({
        path:'/center/buyVipMember',
        query:{
          companyId: this.companyId
        }
      })
    },
    buyMemberDialogClose() {
      this.$router.replace(this.buyMemberDialogTo);
    }
  },
}
</script>
<style lang="scss">
.achievement{
  .el-select,.el-cascader{
    width: 100%;
    .el-input__inner{
      &:read-only{
        cursor:auto;
        background-color: #fff;
      }
    }
  }
  .cert-item{
    width: 100%;
    padding:15px 10px 10px;
    background-color: #fff;
    margin-bottom: 10px;
    .cert-name{
      position: relative;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      padding-right: 50px;
      .btn-text{
        position: absolute;
        right: 0;
        top: 0;
        line-height: 24px;
        cursor: pointer;
        font-size: 14px;
        color: #f75959;
      }
    }
    .cert-pics{
      overflow: hidden;
      margin-top: 15px;
      >li{
        width: 234px;
        height: 150px;
        float: left;
        &:nth-child(even){
          float: right;
        }
      }
      .pic{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .btn-add{
    width: 100%;
    height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #f75959;
    line-height: 22px;
    cursor: pointer;
    .el-icon-plus{
      margin-right:4px;
      font-weight: bold;
    }
    &:hover{
      border-color: #f75959;
    }
  }
  .project-list{
    background-color: #fff;
    margin-bottom: -1px;
    width: 680px;
    padding: 0 10px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    .project-item{
      padding: 10px 0;
      border-bottom: 1px solid #e5e5e5;
      &:last-child{
        border-bottom: 0;
      }
    }
    .flex{
      overflow: hidden;
      margin-bottom: 6px;
      &:nth-child(2){
        padding-right: 50px;
        position: relative;
      }
    }
    .flex-center{
      justify-content: space-between;
      display: flex;
    }
    .name{
      float: left;
      font-size: 16px;
      color: #333;
      line-height: 24px;
      font-weight: bold;
    }
    .time{
      float: right;
      font-size: 14px;
      color: #333;
      line-height: 24px;
    }
    .project-info{
      font-size: 14px;
      color: #333;
      line-height: 24px;
      float: left;
      margin-right: 50px;
      white-space: nowrap;
      .info-label{
        display: inline-block;
        vertical-align: top;
      }
      .value{
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        word-break: break-all;
      }
    }
    .btn-text{
      position: absolute;
      right: 0px;
      top: 0px;
      font-size: 14px;
      color: #f75959;
      line-height: 24px;
    }
  }
  .table{
    border-collapse: collapse;
    text-align: center;
    width: 680px;
    background-color: #fff;
    margin-bottom: -1px;
    th{
      height: 48px;
      font-size: 14px;
      color: #333;
      line-height: 48px;
      border: 1px solid #e5e5e5;
      font-weight: bold;
    }
    td{
      height: 48px;
      font-size: 14px;
      color: #333;
      line-height: 48px;
      border: 1px solid #e5e5e5;
    }
    .btn-text{
      color: #999;
      cursor: pointer;
    }
  }
  .btn-primary{
    width: 100px;
    text-align: center;
  }
}
.form-dialog{
  .inner-form{
    padding-top: 20px;
    .label{
      text-align: right;
    }
    .input-box{
      min-width: 360px;
    }
    .block-date{
      width: 100%;
    }
    .btn-primary{
      display: block;
      margin: 0 auto;
      height: 32px;
      line-height: 32px;
    }
    .sp-select{
      width:160px;
    }
  }
  
  .line{
    display: inline-block;
    width: 20px;
    height: 1px;
    background-color: #e5e5e5;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: -3px;
    vertical-align: middle;
  }
  .date-input{
    width: 160px;
  }
  .btn-upload{
    display: inline-block;
    width: 128px;
    height: 128px;
    margin-right: 15px;
    position: relative;
    &+.btn-upload{
      margin-left: 10px;
    }
  }
  .file-img{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  
  .card-file {
    display:block;
    position: relative;
    width: 128px;
    height: 128px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    cursor:pointer;
    padding-top: 94px;
    font-size: 14px;
    color: #999;
    line-height: 24px;
    text-align: center;
    &:before,
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      border-radius: 2px;
      background-color: #e5e5e5;
    }
    &:before {
      width: 60px;
      height: 8px;
      margin-left: -30px;
      margin-top: -4px;
    }

    &:after {
      width: 8px;
      height: 60px;
      margin-top: -30px;
      margin-left: -4px;
    }
  }
}
.radio-group {
  width: 100%;
  font-size: 40px;
  .el-radio {
    width: 280px;
    padding: 40px 200px 50px 10px;
    margin-right: 0;
  }
  .el-radio__label {
    font-size: 26px !important;
  }
}
</style>